import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TelemarketingService } from './services/telemarketing.service';
import { Telemarketing, Usuario } from './interfaces/telemarketing.interface';
import { MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-telemarketing-form',
  templateUrl: './telemarketing-form.component.html'
})
export class TelemarketingFormComponent implements OnInit, OnChanges, OnDestroy {
  @Input() model: Telemarketing | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  @Output() onCustomizables = new EventEmitter<void>();

  form: FormGroup;
  loading: boolean = false;
  telefonistasDropdown: Usuario[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private telemarketingService: TelemarketingService,
    private messageService: MessageService,
    private dialog: MatDialog
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.loadUsuarios();
    if (this.model) {
      this.form.patchValue(this.model);
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      cvetelefonista: [null, Validators.required],
      numeroempleado: ['', Validators.required],
      nombre: [{ value: '', disabled: true }, Validators.required]
    });

    // Suscribirse a cambios en el campo cvetelefonista
    this.form.get('cvetelefonista')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          this.onTelefonistaSelected(value);
        }
      });
  }

  onTelefonistaSelected(susuario: string): void {
    const selectedUser = this.telefonistasDropdown.find(user => user.susuario === susuario);
    if (selectedUser) {
      this.form.patchValue({
        nombre: selectedUser.nombreusuario.trim()
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && changes['model'].currentValue) {
      this.form.patchValue(changes['model'].currentValue);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadUsuarios(): void {
    this.telemarketingService.getUsuarios().subscribe({
      next: (response) => {
        if (response.success) {
          this.telefonistasDropdown = response.data;
        }
      },
      error: (error) => {
        console.error('Error al cargar usuarios:', error);
      }
    });
  }

  create(): void {
    if (this.form.valid) {
      this.loading = true;
      const formData = this.form.getRawValue();
      
      this.telemarketingService.createTelemarketing(formData).subscribe({
        next: (response) => {
          if (response.success) {
            this.onSave.emit({
              success: true,
              message: 'Telemarketer creado correctamente'
            });
          } else {
            this.onSave.emit({
              success: false,
              message: 'Error al crear el telemarketer'
            });
          }
        },
        error: (error) => {
          console.error('Error al crear:', error);
          this.onSave.emit({
            success: false,
            message: 'Error al crear el telemarketer'
          });
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.getRawValue();
    const payload = {
      que: 2,
      tope: '',
      cmd: '',
      cvetelefonista: this.model.cvetelefonista,
      nombre: formData.nombre,
      nivelseguridad: 0,
      numeroempleado: formData.numeroempleado,
      tipocontrato: '',
      rangO1: 0,
      comisioN1: 0,
      rangO2: 0,
      comisioN2: 0,
      rangO3: 0,
      comisioN3: 0,
      rangO4: 0,
      comisioN4: 0,
      comisionmayor: 0
    };

    this.telemarketingService.updateTelemarketing(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response.success) {
            this.onSave.emit({
              success: true,
              message: 'Telemarketer actualizado correctamente'
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al actualizar el telemarketer'
            });
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al actualizar telemarketer:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al actualizar el telemarketer'
          });
          this.loading = false;
        }
      });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'telefo',
        sClave: `${this.form.get('cvetelefonista')?.value}`,
        sNombre: this.form.get('nombre')?.value,
        sTipo: 'Opcion'
      }
    });
  }
} 